import {
  AnalysisAdditionalInfo,
  AnalysisStatus
} from "../../../../../lib/enums";
import { titleCase } from "../../../../../utils";

export const getTiCoreData = tc => {
  const { additional_information, tc_version } = tc || {};

  const isProcessing =
    additional_information === AnalysisAdditionalInfo.PROCESSING;

  const isVersionAvailable =
    additional_information &&
    tc_version &&
    additional_information !== AnalysisAdditionalInfo.PROCESSING;

  const analysisVersion = isVersionAvailable ? tc_version : null;

  return { isProcessing, analysisVersion };
};

export const getTiCloudData = cloud => {
  const { display_status, additional_information, last_completed_on } =
    cloud || {};

  const isProcessing = [
    AnalysisStatus.UPLOADING,
    AnalysisStatus.ANALYZING
  ].includes(display_status);

  const isConfigured =
    additional_information !== AnalysisAdditionalInfo.NOT_CONFIGURED;

  const lastAnalysis = last_completed_on || null;

  return { isProcessing, isConfigured, lastAnalysis };
};

export const getRLCloudSandboxData = rlCloudSandbox => {
  const {
    display_status,
    status_code: statusCode,
    last_completed_on: lastCompletedOn,
    additional_information,
    enabled,
    analysis_status: analysisStatus
  } = rlCloudSandbox || {};

  const isProcessing = [
    AnalysisStatus.QUEUED,
    AnalysisStatus.PROCESSING,
    AnalysisStatus.REANALYZING
  ].includes(display_status);

  const isConfigured =
    additional_information !== AnalysisAdditionalInfo.NOT_CONFIGURED;

  const fileTypeSupported =
    additional_information !== AnalysisAdditionalInfo.NOT_SUPPORTED;

  const fileOversized =
    additional_information === AnalysisAdditionalInfo.FILE_OVERSIZED;

  const neverSubmitted =
    additional_information === AnalysisAdditionalInfo.NEVER_SUBMITED;

  const informationToDisplay = additional_information || display_status || null;
  const helpMessage = informationToDisplay && titleCase(informationToDisplay);

  const additionalMessage =
    enabled && informationToDisplay ? informationToDisplay : null;

  return {
    isProcessing,
    lastCompletedOn,
    isConfigured,
    fileOversized,
    fileTypeSupported,
    neverSubmitted,
    helpMessage,
    additionalMessage,
    analysisStatus,
    statusCode
  };
};
